/* Version: 3.5.155 */
'use client';
import _extends from '@babel/runtime/helpers/extends';
import Card from './Card.js';
import CardAction from './CardAction.js';
import CardContent from './CardContent.js';
import CardHeader from './CardHeader.js';
import CardImage from './CardImage.js';
import CardSeparator from './CardSeparator.js';
import { FONT_SIZE, HEADER_LEVEL } from './constants.js';

var index = _extends(Card, {
  Action: CardAction,
  Content: CardContent,
  Header: CardHeader,
  Image: CardImage,
  Separator: CardSeparator,
  FONT_SIZE: FONT_SIZE,
  HEADER_LEVEL: HEADER_LEVEL
});

export { CardAction, CardContent, CardHeader, CardImage, CardSeparator, FONT_SIZE, HEADER_LEVEL, index as default };
